import { useTheme } from 'styled-components';

import { None } from 'components/data/helpers';
import { Theme } from 'utils/color/horizonTheme';

import { type TTurbineProps } from '../types';

import {
  ListItemLabel,
  ListItemValue,
  RowContainer,
  StyledList,
  StyledListItem,
} from './PointsList.style';

interface ITurbinePointMapProps {
  data: Array<TTurbineProps>;
  onItemClick: any;
  selectedTurbineIndex: number;
  mapHeight: string;
}

export function PointsList(props: ITurbinePointMapProps) {
  const theme = useTheme();
  const { data, onItemClick, selectedTurbineIndex, mapHeight } = props;

  function handleItemClick(item: TTurbineProps, index: number) {
    onItemClick(item, index);
  }

  const selectedBackgroundColor = (index: number) =>
    selectedTurbineIndex === index
      ? theme.themeName === Theme.Dark
        ? theme.tableAccentColor
        : theme.selectedListItemBackground
      : theme.secondaryBackgroundColor;

  return (
    <StyledList
      overflowy={'auto'}
      mapheight={mapHeight}
      itemLayout="vertical"
      dataSource={data}
      renderItem={(item: TTurbineProps, index: number) => (
        <StyledListItem
          key={index}
          backgroundcolor={selectedBackgroundColor(index)}
          onClick={_e => {
            handleItemClick(item, index);
          }}
        >
          <RowContainer>
            <ListItemLabel>Name: </ListItemLabel>
            <ListItemValue>{item?.content?.props?.turbine?.name ?? <None />}</ListItemValue>
          </RowContainer>
          <RowContainer>
            <ListItemLabel>Latitude: </ListItemLabel>
            <ListItemValue>{item?.position?.lat ?? <None />}</ListItemValue>
          </RowContainer>
          <RowContainer>
            <ListItemLabel>Longitude: </ListItemLabel>
            <ListItemValue>{item?.position?.lng ?? <None />}</ListItemValue>
          </RowContainer>
        </StyledListItem>
      )}
    />
  );
}
